import React from "react";
import AdminManagersContainer from "../../components/Admin/Managers/";
const AdminManagers = props => {
  return <AdminManagersContainer {...{ ...props }} />;
};
export default AdminManagers;
